var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "selected-customer-info" }, [
    _c(
      "div",
      { attrs: { id: "customer-info-right" } },
      _vm._l(_vm.addressInfo, function(item, index) {
        return _c("p", { key: index, attrs: { id: "customer-paragraph" } }, [
          _c("span", [_vm._v(_vm._s(item))])
        ])
      }),
      0
    ),
    _vm._v(" "),
    _c("div", { attrs: { id: "customer-info-left" } }, [
      _vm.customerLocked
        ? _c("p", { attrs: { id: "customer-paragraph" } }, [
            _c("span", { attrs: { id: "selected-customer-locked" } }, [
              _vm._v("KUNDE IST GESPERRT!")
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isCoCustomer
        ? _c("p", { attrs: { id: "customer-paragraph" } }, [
            _c("span", { attrs: { id: "selected-co-customer" } }, [
              _vm._v("Kunde ist Software-Mitbenutzer!")
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("p", { attrs: { id: "customer-paragraph" } }, [
        _c("span", [
          _vm._v("Update-Berechtigt: " + _vm._s(_vm.updatesAuthorized))
        ])
      ]),
      _vm._v(" "),
      _c("p", { attrs: { id: "customer-paragraph" } }, [
        _c("span", [_vm._v(_vm._s(_vm.osaRegistrationMsg))])
      ]),
      _vm._v(" "),
      _c("p", { attrs: { id: "customer-paragraph" } }, [
        _c("span", [_vm._v("Debitorennummer: " + _vm._s(_vm.debitorennummer))])
      ]),
      _vm._v(" "),
      _vm.siteKundennummer && _vm.siteKundennummer.trim().length > 0
        ? _c("p", { attrs: { id: "customer-paragraph" } }, [
            _c("span", [
              _vm._v("SITE-Kundennummer: " + _vm._s(_vm.siteKundennummer))
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("p", { attrs: { id: "customer-paragraph" } }, [
        _c("span", [_vm._v("Kundengruppe: " + _vm._s(_vm.kundengruppe))])
      ]),
      _vm._v(" "),
      _c("p", { attrs: { id: "customer-paragraph" } }, [
        _c("span", [_vm._v("Produktlinien:  " + _vm._s(_vm.produktlinien))])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }